import OmniApiClient from "./base";

export const priceAlertsApi = {
  getQogitaCronStatus: () =>
    OmniApiClient.get("/price-alerts/cron/qogita/status"),

  startQogitaCron: (body) =>
    OmniApiClient.post("/price-alerts/cron/qogita/start", body),

  stopQogitaCron: () => OmniApiClient.post("/price-alerts/cron/qogita/stop"),

  runQogitaCron: (body = {}) =>
    OmniApiClient.post("/price-alerts/cron/qogita/run", body),

  getKeepaCronStatus: () =>
    OmniApiClient.get("/price-alerts/cron/keepa/status"),

  startKeepaCron: (body) =>
    OmniApiClient.post("/price-alerts/cron/keepa/start", body),

  stopKeepaCron: () => OmniApiClient.post("/price-alerts/cron/keepa/stop"),

  runKeepaCron: (body = {}) =>
    OmniApiClient.post("/price-alerts/cron/keepa/run", body),

  testDiscordWebhook: (discord_webhook) =>
    OmniApiClient.post("/price-alerts/cron/discord/test", { discord_webhook }),
};
